<div class="container">
  <div class="row justify-content-center">
    <div class="col-lg-12">
      <div class="title mb-4">
        <h1>Career Opportunities</h1>
        <p class="career-text mb-1">
          Whether you need a CDL, a truck driver job, or both; we have you covered with
          best-in-class training and great pay is just the start to take your career to the next
          level. We have open lanes in our Dedicated, Regional, National, and Intermodal divisions
          allowing you to choose your lane. All of our jobs include highly competitive pay, health
          and retirement benefits, and the industry’s best equipment. We are seeking truck drivers
          that have a safe and clean record and can handle 12 Gears, 18 Wheels, 40 Tons, 80 Feet,
          and 400 Horsepower! If that sounds anything like you -
          <a href="https://career.crengland.com/application">Apply Now!</a>
        </p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <a class="pointer" [routerLink]="['/jobs/', { division: 'DEDICT' }]">
        <div class="row row-mobile popu-category-box mt-4">
          <div class="col-6 col-sm-12 popu-category-icon mb-3 blue">
            <i class="far fa-handshake"></i>
          </div>
          <div class="col-6 col-sm-12">
            <div class="popu-category-content">
              <h5 class="f-18 text-dark">Dedicated</h5>
            </div>
            <div class="popu-category-bullets" *ngFor="let bullet of dedicated.JobBullets">
              <div class="text-dark">{{ bullet }}</div>
            </div>
            <div class="popu-category-url">
              <a [routerLink]="['/jobs/', { division: 'DEDICT' }]">View Dedicated Jobs</a>
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="col">
      <a class="pointer" [routerLink]="['/jobs/', { division: 'OVER_THE_ROAD' }]">
        <div class="row row-mobile popu-category-box mt-4">
          <div class="col-6 col-sm-12 popu-category-icon mb-3 yellow">
            <i class="far fa-map-marked-alt"></i>
          </div>
          <div class="col-6 col-sm-12">
            <div class="popu-category-content">
              <h5 class="f-18 text-dark">Over the Road</h5>
            </div>
            <div class="popu-category-bullets" *ngFor="let bullet of otr.JobBullets">
              <div class="text-dark">{{ bullet }}</div>
            </div>
            <div class="popu-category-url">
              <a [routerLink]="['/jobs/', { division: 'OVER_THE_ROAD' }]"
                >View Over the Road Jobs</a
              >
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="col">
      <a class="pointer" [routerLink]="['/jobs/', { division: 'INTMDL' }]">
        <div class="row row-mobile popu-category-box mt-4">
          <div class="col-6 col-sm-12 popu-category-icon mb-3 skyblue">
            <i class="far fa-train"></i>
          </div>
          <div class="col-6 col-sm-12">
            <div class="popu-category-content">
              <h5 class="f-18 text-dark">Intermodal</h5>
            </div>
            <div class="popu-category-bullets" *ngFor="let bullet of intermodal.JobBullets">
              <div class="text-dark">{{ bullet }}</div>
            </div>
            <div class="popu-category-url">
              <a [routerLink]="['/jobs/', { division: 'INTMDL' }]">View Intermodal Jobs</a>
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="col">
      <a class="pointer" [routerLink]="['/jobs/', { experience: '0' }]">
        <div class="row row-mobile popu-category-box mt-4">
          <div class="col-6 col-sm-12 popu-category-icon mb-3 red">
            <i class="far fa-graduation-cap"></i>
          </div>
          <div class="col-6 col-sm-12">
            <div class="popu-category-content">
              <h5 class="f-18 text-dark">I need my CDL</h5>
            </div>
            <div class="popu-category-bullets" *ngFor="let bullet of noCdl.JobBullets">
              <div class="text-dark">{{ bullet }}</div>
            </div>
            <div class="popu-category-url">
              <a [routerLink]="['/jobs/', { experience: '0' }]">View Entry-Level Jobs</a>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</div>
